import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { AppConfig } from "../../../AppConfig";
import { LocalStorageManager } from "../../../core/storage/LocalStorageManager";

export const useLegalForUse = () => {
  const location = useLocation();
  const { query } = useParams();

  useEffect(() => {
    LocalStorageManager.Instance.saveObject<string>(
      AppConfig.Instance.LocalStorageKey["viewedTermsOfUse"],
      new Date().toISOString(),
    );

    if (location.hash) {
      // if url includes #term_of_service, scroll to term of service section
      if (location.hash.includes("#term_of_service")) {
        const termOfService = document.getElementById("term_of_service");
        termOfService?.scrollIntoView({ behavior: "smooth" });
      }

      // if url includes #privacy_policy, scroll to privacy policy section
      if (location.hash.includes("#privacy_policy")) {
        const privacyPolicy = document.getElementById("privacy_policy");
        privacyPolicy?.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location.hash]);

  return { query };
};
